import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";
import {Dialog} from "primereact/dialog";

import _FM_ReceiptListComponent from "../components/_FM_receipt/_FM_ReceiptListComponent";
import _FM_ReceiptFormComponent from "../components/_FM_receipt/_FM_ReceiptFormComponent";
import _FM_ReceiptShowComponent from "../components/_FM_receipt/_FM_ReceiptShowComponent";
import _FM_ReceiptItemFormComponent from "../components/_FM_receipt/_FM_ReceiptItemFormComponent";
import HelpComponent from "../components/HelpComponent";
import {Message} from "primereact/message";
import _FM_FolioFormComponent from "../components/_FM_folio/_FM_FolioFormComponent";
import _FM_ReservationgroupShowComponent from "../components/_FM_reservationgroup/_FM_ReservationgroupShowComponent";
import _FM_CustomerShowComponent from "../components/_FM_customer/_FM_CustomerShowComponent";

const _FM_ReceiptPage = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {entity, action, id} = useParams();

  useEffect(() => {
    document.title = t('receipts') + ' - ' + process.env.REACT_APP_TITLE;
    window.App.help('/receipt')
  }, []);

  return (
    <div className="_FM_ReceiptPage p-component p-m-lg-4">
      <HelpComponent type={"site"} position={"TOP_OF_THE_PAGE"} url={"/receipt"}/>
      <Panel>
        <_FM_ReceiptListComponent />
      </Panel>
      <Sidebar position="right" visible={action === 'create' || action === 'update'} closeOnEscape={true}
               style={{width: '99%'}}
               onHide={() => {
                 navigate(-1);
               }}>
        <_FM_ReceiptFormComponent />
      </Sidebar>
      <Sidebar position="right" visible={action === 'read'} closeOnEscape={true}
               style={{width: '99%'}}
               onHide={() => {
                 navigate(-1);
               }}>
        <_FM_ReceiptShowComponent />
      </Sidebar>
      <Dialog visible={window.App.urlVars().read === 'reservationGroup'}
              header={t('reservation_group')}
              footer={<React.Fragment><Message className={"w-100"} style={{background: 'transparent'}} severity="info" text={t("dialog_movable")} /></React.Fragment>}
              onHide={() => {
                navigate(-1)
              }}
              modal={false}
              style={{minWidth: '980px', width: '980px', maxWidth: '980px'}}>
        <_FM_ReservationgroupShowComponent reservationGroupId={window.App.urlVars().reservationGroupId} />
      </Dialog>
      <Dialog visible={window.App.urlVars().read === 'customer'}
              header={t('customer')}
              footer={<React.Fragment><Message className={"w-100"} style={{background: 'transparent'}} severity="info" text={t("dialog_movable")} /></React.Fragment>}
              onHide={() => {
                navigate(-1)
              }}
              modal={false}
              style={{minWidth: '980px', width: '980px', maxWidth: '980px'}}>
        <_FM_CustomerShowComponent />
      </Dialog>
    </div>
  )
}
export default withTranslation('common')(_FM_ReceiptPage);
